import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store/index.js'
import mixin from '@/mixin/mixin.js'
import initRemAdaptation from '@/utils/rem.js'
import Vant from 'vant';
import { Toast } from 'vant';
import 'vant/lib/index.css';

import pageContent from "@/components/page-content/page-content.vue";
import navBar from "@/components/nav-bar/nav-bar.vue";

Vue.config.productionTip = false;
Vue.prototype.$message = Toast;
Vue.prototype.$message.error = Toast.fail;

// 全局注册组件
Vue.component('page-content', pageContent);
Vue.component('nav-bar', navBar);



// 在Vue中使用全局混入
Vue.mixin(mixin);
Vue.use(Vant);

// 初始化响应式rem适配
initRemAdaptation();
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
